import { axiosInstance, readFromToken } from "./auth.ts";
import { Navigate, useNavigate } from "react-router-dom";

const onError = (error) => {
  if (error.response.status === 401) {
    // if signed in
    if (readFromToken() && error.response.data.msg === 'Token has expired') {
      window.location.href = '/signout'
    }
  }
}

export const getWeeklySchedule = async () => {
  return await axiosInstance.get(
    "/api/get_user_appointments",
  ).then((response) => response.data
  ).catch(onError);
};

export const getWorkingHours = async () => {
  return await axiosInstance.get(
    "/api/get_working_hours",
  ).then((response) => response.data
  ).catch(onError);
};

export const getConfig = async () => {
  return await axiosInstance.get(
    "/api/get_config",
  ).then((response) => response.data
  ).catch(onError);
};

export const getClinicWeeklySchedule = async () => {
  return await axiosInstance.get(
    "/api/get_clinic_appointments",
  ).then((response) => response.data
  ).catch(onError);
};

export const getUnauthorizedUserCount = async () => {
  return await axiosInstance.get(
    "/api/get_unauthorized_user_count",
  ).then((response) => response.data
  ).catch(onError);
};

export const getUsers = async () => {
  return await axiosInstance.get(
    "/api/get_users",
  ).then((response) => response.data
  ).catch(onError);
};

export const getAllAnnouncements = async () => {
  return await axiosInstance.get(
    "/api/get_all_announcements",
  ).then((response) => response.data
  ).catch(onError);
};

export const setAddAnnoucement = async (data) => {
  const response = await axiosInstance.post(
    "/api/add_announcement",
    data
  );
  return response;
};

export const setConfig = async (data) => {
  const response = await axiosInstance.post(
    "/api/set_config",
    data
  );
  return response;
};

export const setDeleteAnnouncement = async (data) => {
  const response = await axiosInstance.post(
    "/api/delete_announcement",
    data
  );
  return response;
};


export const setSendResetToken = async (data) => {
  const response = await axiosInstance.post(
    "/api/send_reset_token",
    data
  );
  return response;
};

export const setUpdatePassword = async (data) => {
  const response = await axiosInstance.post(
    "/api/update_password",
    data
  );
  return response;
};

export const setRegister = async (data) => {
  const response = await axiosInstance.post(
    "/api/register",
    data
  );
  return response;
};

export const setAuthorizeUser = async (data) => {
  const response = await axiosInstance.post(
    "/api/authorize_user",
    data
  );
  return response;
};

export const setPromoteUser = async (data) => {
  const response = await axiosInstance.post(
    "/api/promote_user",
    data
  );
  return response;
};

export const setDemoteUser = async (data) => {
  const response = await axiosInstance.post(
    "/api/demote_user",
    data
  );
  return response;
};

export const setDeleteUser = async (data) => {
  const response = await axiosInstance.post(
    "/api/delete_user",
    data
  );
  return response;
};

export const setLogin = async (data) => {
  const response = await axiosInstance.post(
    "/api/login",
    data
  );
  return response;
};

export const setAppointment = async (data) => {
  const response = await axiosInstance.post(
    "/api/schedule_appointment",
    data
  );
  return response;
};

export const cancelAppointment = async (data) => {
  const response = await axiosInstance.post(
    "/api/cancel_user_appointment",
    data
  );
  return response;
};

export const setSlotState = async (data) => {
  const response = await axiosInstance.post(
    "/api/set_slot_state",
    data
  );
  return response;
};

export const setMultipleSlotStates = async (data) => {
  const response = await axiosInstance.post(
    "/api/set_multiple_slot_states",
    data
  );
  return response;
};

